import React from 'react';
import BaseComponent from './BaseComponent';

export default class LoadingOverlay extends BaseComponent {


  render() {
    return (
      <div className="loading-overlay">
        <img src={require("WebsiteApp/assets/oval.svg")} alt="loader"/>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/LoadingOverlay.js